
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 513","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 .6C115.3.6 0 115.9 0 256.6s115.3 256 256 256 256-115.3 256-256S398.1.6 256 .6zm0 482.5c-124.6 0-226.5-101.9-226.5-226.5S131.4 30.1 256 30.1 482.5 132 482.5 256.6 380.6 483.1 256 483.1z"}}),_c('path',{attrs:{"d":"M256 121.3c-75.1 0-135.4 60.3-135.4 135.4S180.9 392 256 392s135.4-60.3 135.4-135.4S331.1 121.3 256 121.3zm0 241.2c-57.6 0-105.9-46.9-105.9-105.9S197 150.7 256 150.7s105.9 46.9 105.9 105.9S315 362.5 256 362.5z"}}),_c('path',{attrs:{"d":"M256 188.3c-37.5 0-68.4 30.8-68.4 68.4 0 37.5 30.8 68.4 68.4 68.4 37.5 0 68.4-30.8 68.4-68.4s-29.5-68.4-68.4-68.4zm0 107.2c-21.4 0-38.9-17.4-38.9-38.9s17.4-38.9 38.9-38.9 38.9 17.4 38.9 38.9-17.5 38.9-38.9 38.9z"}})])
          )
        }
      }
    